import { CreateFlashMessageDto } from '../../../dto/flashmessage/create/createflashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface CreateFlashMessageResponse extends MiddlewareAPIResponse
{
    getFlashMessageResponseDto(): CreateFlashMessageDto;
}

export class CreateFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements CreateFlashMessageResponse
{
    private getFlashMessageDto : CreateFlashMessageDto;

    getFlashMessageResponseDto(): CreateFlashMessageDto
    {
        return this.getFlashMessageDto;
    }

    setFlashMessageResponseDto(getFlashMessageDto: CreateFlashMessageDto)
    {
        this.getFlashMessageDto = getFlashMessageDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/create/createflashmessagesresponse.tsx